import { Component, useEffect } from 'react';
import ReactDOM, { createPortal } from 'react-dom';

function Portal({children}) {
  const mount = document.getElementById('portal');
  const element = document.createElement("div");
  element.className = "absolute z-50 w-screen h-screen flex justify-center items-center";

  useEffect(() => {
    mount.appendChild(element);
    return () => mount.removeChild(element);
  }, [element, mount]);

  return createPortal(children, element);
}

export default Portal;

{/*
const portalRoot = document.getElementById('portal');

export default class Portal extends Component {
  constructor() {
    super();
    this.el = document.createElement("div");
  }

  componentDidMount = () => {
    portalRoot.appendChild(this.el);
  };

  componentWillUnmount = () => {
    portalRoot.removeChild(this.el);
  };

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}
*/}
